/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import Grid from "@mui/material/Grid";
import BirdMapIcon from "../../../../assets/img/jobs/karte_bird.png";
import birdMapSectionStyle from "./birdMapSectionStyle";
import Typography from "@mui/material/Typography";
import {Box} from "@mui/material";

const BirdMapSection = () => {
  return (
    <Container sectionPadding={true} sx={birdMapSectionStyle.container}>
      <Typography variant={"subtitle1"} sx={birdMapSectionStyle.subheadline}>
        Bei uns gibt es Experten für jeden Rechtsbereich und wir arbeiten komplett digital. Das heißt für Sie: Keine langen Wartezeiten mehr und kein lästiger
        Papierkram. Sie können sich jederzeit und von überall um Ihren Rechtsfall kümmern!
      </Typography>
      <Grid container justifyContent={"center"}>
        <Box component={"img"} sx={birdMapSectionStyle.mapIcon} src={BirdMapIcon} alt={"Legalbird Partnernetwerk Karte"} />
      </Grid>
    </Container>
  );
};

export default BirdMapSection;
